export function getIsAndroid() {
  return (
    typeof window !== "undefined" &&
    typeof navigator !== "undefined" &&
    /Android/i.test(navigator.userAgent)
  );
}
